<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { showSwbRealComBankAcctSaveDialog } from './selectDlg'
    //
    import merchtComnApi from '../../api/merchtComn'
    import userApi from '../../api/user'
    //
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';
    import SwbQuerySortArea from '../query/QuerySortArea.vue'
    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);
    Vue.regist(SwbQuerySortArea);

    import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';
    Vue.regist(SwbPopoverOrgTree);
    //
    export default {
        name: 'swb-real-com-bank-acct-list-select',
        desc: '实体公司银行账号',
        path: "/bank/acct/list/select",
        props: ['checkBox', 'realComId', 'usage'],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                lastPageNumber: null,
                //
                confKey: "swb-real-com-bank-acct-list",
                theTableHeight: 500,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: true, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                queryOnLoad: true,
                //
                bankAcctUsageMap: getEnumMap("bankAcctUsage", "value2text"),
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                enableStateMap: getEnumMap("enableState", "value2text"),
            }
        },
        created: function () {
            //
            if(!Utils.isNoB(this.checkBox) && Utils.isTrue(this.checkBox)) {
                this.multiSelect = true;
                this.multiPageSelect = true;
                this.rowNoShow = false;
            }
            this.getRealComBankAcctList();
        },
        mounted() {
            //
            this.initResultTable();
        },
        methods: {
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'usage': function (row, colName, colValue, rowIndex, btnName) {
                        return '<span>' + self.bankAcctUsageMap[row.usage] + '</span>';
                    },
                    'verified': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.verified) {
                            return '<span class="swb-tags swb-tags-danger">' + "已验证" + '</span>'
                        } else {
                            return '<span class="swb-tags swb-tags-success">' + "未验证" + '</span>'
                        }
                    },
                    'locked': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.locked) {
                            return '<span class="swb-tags swb-tags-danger">' + "已锁定" + '</span>'
                        }
                    },
                    'frozen': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.frozen) {
                            return '<span class="swb-tags swb-tags-danger">' + "已冻结" + '</span>'
                        }
                    },
                    'defaulted': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.defaulted) {
                            return '<span>' + "是" + '</span>'
                        }
                    },
                    'enableState': function (row, colName, colValue, rowIndex) {
                        return self.enableStateMap[row.enableState];
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        btnList.push({name: 'modify', text: '编辑'});
                        if(!row.defaulted && !row.frozen && !row.locked) {
                            btnList.push({name: 'defaulted', text: '默认'});
                        }
                        if(Utils.isTrue(row.locked)) {
                            btnList.push({name: 'unLock', text: '解锁'});
                        }
                        if(Utils.isTrue(row.frozen)) {
                            btnList.push({name: 'unFrozen', text: '解冻'});
                        }
                        if(Utils.isFalse(row.locked) && !row.defaulted) {
                            btnList.push({name: 'lock', text: '锁定'});
                        }
                        if(Utils.isFalse(row.frozen) && !row.defaulted) {
                            btnList.push({name: 'frozen', text: '冻结'});
                        }
                        if(!row.defaulted) {
                            btnList.push({name: 'delete', text: '删除'});
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'modify') {
                            self.createBankAcct(row.id);
                        } else if(btnName == 'delete') {
                            self.deleteCostCenter(row.id);
                        } else if(btnName == 'unLock') {
                            self.unlocked(row.id, false)
                        } else if(btnName == 'lock') {
                            self.unlocked(row.id, true)
                        } else if(btnName == 'unFrozen') {
                            self.unFrozen(row.id, false)
                        } else if(btnName == 'frozen') {
                            self.unFrozen(row.id, true)
                        } else if(btnName == 'defaulted') {
                            self.setDefaulted(row.id, true)
                        }
                    }
                });
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getRealComBankAcctList();
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            checkComCatChange: function (eventData) {
                this.selectRealComId = eventData.id;
                //
                this.getRealComBankAcctList();
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                //缓存查询条件
                this.getRealComBankAcctList();
            },
            getRealComBankAcctList: function () {
                let self = this;
                let postData = {};
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if(!Utils.isNoB(this.realComId)) {
                    filterItems.realComId = this.realComId || null;
                }
                if(!Utils.isNoB(this.usage)) {
                    filterItems.usage = this.usage || null;
                }
                filterItems.enableState = 1;
                // filterItems.verified = true;
                filterItems.locked = false;
                filterItems.frozen = false;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let loading = MsgBox.loading();
                merchtComnApi.getRealComBankAcctList(postData, function (result) {
                    loading.hide();
                    if(result.type == "info") {
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(result.data.rows, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDlgResult: function () {
                let result = {
                    type: 'info'
                };
                let selectList = this.getTableSelection();
                if(Utils.isTrue(this.checkBox)) {
                    if(!Utils.isNoB(selectList) && selectList.length > 0) {
                        //
                        result.data = selectList;
                    } else {
                        result.type = 'wran';
                        result.message = "请选择银行账号信息";
                    }
                } else {
                    if(Utils.isNoB(selectList)) {
                        result.type = "warn";
                        result.message = "请选择银行账号信息！";
                        return result;
                    } else {
                        result.data = selectList;
                    }
                }
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/merchtFinac/RealComBankAcctListSelect.vue